/**
 * E-mailvalidatie + normalisatie — single source of truth.
 *
 * Vóór deze utility had elk formulier zijn eigen (te losse) check, waardoor
 * typefouten als `info@bedrijf.nl.` (trailing dot), `naam@g..com` (dubbele
 * punt) en `naam@gmail.@om` (tweede @) tot aan Resend's `to`-veld kwamen en
 * daar een 422 `validation_error` veroorzaakten. Resultaat: lead kreeg nooit
 * de bevestigingsmail én de Resend-log liep vol.
 *
 * Gebruik `isValidEmail()` als gate op formulieren en `normalizeEmail()` vlak
 * vóór verzending. Beide functies zijn puur (client- én server-safe).
 */

/**
 * Trim, lowercase en strip trailing dots. Een trailing dot (`...nl.`) is een
 * veilig herstelbare typefout en wordt automatisch weggehaald; alle andere
 * fouten laten we staan zodat isValidEmail ze kan afkeuren.
 */
export function normalizeEmail(raw: string | null | undefined): string {
  return (raw ?? "").trim().toLowerCase().replace(/\.+$/, "");
}

/**
 * Striktere structuurcheck dan de oude regexes:
 *   - geen opeenvolgende punten (`..`)
 *   - geen punt direct naast de @ (`.@` of `@.`)
 *   - precies één @
 *   - TLD van minstens 2 letters
 * Normaliseert eerst, dus `info@bedrijf.nl.` wordt geaccepteerd (→ ...nl).
 */
export function isValidEmail(raw: string | null | undefined): boolean {
  const e = normalizeEmail(raw);
  if (!e || e.includes("..") || e.includes(".@") || e.includes("@.")) return false;
  if (e.startsWith(".") || (e.split("@").length - 1) !== 1) return false;
  return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/.test(e);
}
